import { Pipe, PipeTransform } from '@angular/core';
import { PackageServicesService } from '../dashboard/marketing/promotions/components/packages/package-form/packageServices.service';

@Pipe({
  name: 'fixedNumber'
})
export class FixedNumberPipe implements PipeTransform {
  constructor(private _packageServicesService: PackageServicesService) {}
  transform(value: number): number {
    const fixedNumber = this._packageServicesService.fixedNumber(value);
    return fixedNumber;
  }

}
